<template>
  <Header />
  <article>
    <div class="kv">
      <div class="caption">
        <h1>減碳的努力</h1>
      </div>
    </div>
    <section class="sect1">
      <div class="ctx">
        <p>和平電力積極評估可替代煤炭的燃料，我們先想到了「天然氣」，但台灣東部並無天然氣管線且受限於地形、地震及颱風直撲的影響，設置天然氣接收站並發展燃氣發電非常困難。</p>
        <p>和平電廠是燃煤電廠，在無法轉型為天然氣發電下，減碳的方式就必須從提升發電機組效率、尋找可替代煤炭的燃料著手。</p>
        <br>
        <br>
        <div class="left">
          <div class="sectTit">解決都市垃圾問題<br>協同減少溫室氣體排放</div>
          <p>遠古時代，人類燒木材、燒牛糞煮飯或取暖，拿單純的廢棄物當燃料，這就是最直接了當的「生質能」，而固體再生燃料則是將適燃的廢棄物，包括廢塑膠、廢木材、廢布料和分選後的垃圾，加以均質化、形成單一性質的燃料。我們在思考利用生質能（木質顆粒）、固體再生燃料（SRF）等來替代部分煤源。</p>
          <p>和平電力自 2021 年開始陸續委託 RWE、中興大學教授、Valmet……等國內外多家專業單位，針對各類可替代的燃料包含混參比例、燃燒模擬、運輸、防火防爆、安全貯存及輸運等進行評估，確保在整體系統安全穩定下使用，並作為未來投入改造的依據。</p>
        </div>
        <div class="right">
          <div class="imgContainer1-1"></div>
        </div>
        <div class="clear"></div>
      </div>
    </section>
    <section class="sect2">
      <div class="ctx">
        <div class="sectTit">提升發電效能 <span class="phoneBreak">低壓汽輪機改造計畫</span></div>
        <swiper
          :modules = "modules"
          :slides-per-view="1"
          :space-between="1"
          :autoplay="{delay:3000, disableOnInteraction:false}"
          :speed="1000"
          :loop="true"
          :pagination="{clickable:true}"
          @swiper="onSwiper"
          @slideChange="onSlideChange"
          class="swiper"
        >
          <swiper-slide class="cover cover1"></swiper-slide>
          <swiper-slide class="cover cover2"></swiper-slide>
          <swiper-slide class="cover cover3"></swiper-slide>
        </swiper>
      </div>
    </section>
    <section class="sect3">
      <div class="ctx">
        <div class="improve">
          <div class="icon">
            <img src="../../assets/energyTransitionReduceCarbon/icon3_01.png" />
          </div>
          <div class="desp">
            <div>和平電力投入了 9 億台幣進行「低壓汽輪機」改造計畫，分別在 2021 年及 2023 年改造了二號機、一號機的低壓汽輪機，強化熱能有效利用，這可提升發電效率約 1.66%，相當於單部機組提升12MW，兩部共等同節省約 5.8 萬噸用煤量，等效節省碳排放量 13.2 萬噸。</div>
            <p>雖然投入龐大金額對照減碳數字看起來不夠突出，但對於和平電力來說，為了 1% 減碳我們都願意嘗試各種可能性去改善。</p>
          </div>
          <div class="spec">
            <div class="imgContainer3-1"></div>
          </div>
        </div>
      </div>
    </section>
  </article>
  <Footer />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { ImgContainerAutoResize } from '../../util/util';
import Header from '../../components/Header.vue';
import Footer from '../../components/Footer.vue';

import { Swiper, SwiperSlide } from 'swiper/vue';
import { Navigation, Pagination, Scrollbar, A11y, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';

export default defineComponent({
  name: 'EnergyTransitionReduceCarbon',
  components: {
    Header,
    Footer,
    Swiper,
    SwiperSlide
  },
  setup() {
    const onSwiper = (swiper: any) => {
      console.log(swiper);
    };
    const onSlideChange = () => {
      console.log('slide change');
    };
    return {
      onSwiper,
      onSlideChange,
      modules: [Navigation, Pagination, Scrollbar, A11y, Autoplay]
    };
  },
  data() {
    return {
    }
  },
  methods:{
  },
  mounted() {
    new ImgContainerAutoResize(document.querySelector(".kv") as HTMLElement, 0.368);
    new ImgContainerAutoResize(document.querySelector(".imgContainer1-1") as HTMLElement, 0.95);
    new ImgContainerAutoResize(document.querySelector(".swiper .cover1") as HTMLElement, 0.55);
    new ImgContainerAutoResize(document.querySelector(".swiper .cover2") as HTMLElement, 0.55);
    new ImgContainerAutoResize(document.querySelector(".swiper .cover3") as HTMLElement, 0.55);
    new ImgContainerAutoResize(document.querySelector(".imgContainer3-1") as HTMLElement, 0.90);
  }
});
</script>

<style>
.kv {
  height: 700px;
  position: relative;
  background: url("@/assets/energyTransitionReduceCarbon/kv.webp");
  background-position: center bottom;
  background-size: cover;
}

.kv .caption {
  width: 1200px;
  margin: 0 auto;
  padding: 25px 0;
  box-sizing: border-box;
}

.kv .caption h1 {
  margin: 0;
  display: inline-block;
  letter-spacing: 5px;
  font-weight: bold;
  font-size: 52px;
  color: #fff;
  text-shadow: 5px 5px 5px #00000066;
}

.sect1 {
  background: #F4F3F3;
}

.sect1 p {
  line-height: 2em;
}

.sect1 .left {
  width: 45%;
  float: left;
}

.sect1 .left .sectTit {
  margin: 0 0 10px;
  padding: 5px 0;
  box-sizing: border-box;
  display: inline-block;
  border-top: solid 1px #0C5F99;
  border-bottom: solid 1px #0C5F99;
  letter-spacing: 2px;
  font-size: 24px;
  color: #0C5F99;
}

.sect1 .right {
  width: 45%;
  float: right;
}

.sect1 .right .imgContainer1-1 {
  flex: 0 0 100%;
  background: url(../../assets/energyTransitionReduceCarbon/pic1_01.png) center no-repeat;
  background-size: cover;
}

.sect2 {
  background: #63BFAA;
}

.sect2 .sectTit {
  margin: 0 0 20px;
  letter-spacing: 3px;
  text-align: center;
  font-size: 36px;
  color: #fff;
}

.sect2 .swiper {
  border-radius: 20px;
}

.sect2 .swiper .swiper-wrapper {
  /* overflow: hidden; */
}

.sect2 .swiper .cover1 {
    background: url(../../assets/energyTransitionReduceCarbon/carousel2_01.webp) center;
    background-size: cover;
}

.sect2 .swiper .cover2 {
    background: url(../../assets/energyTransitionReduceCarbon/carousel2_02.webp) center;
    background-size: cover;
}

.sect2 .swiper .cover3 {
    background: url(../../assets/energyTransitionReduceCarbon/carousel2_03.webp) center;
    background-size: cover;
}

.sect2 .swiper .swiper-pagination {
  /* bottom: -40px !important; */
}

.sect2 .swiper .swiper-pagination .swiper-pagination-bullet {
  width: 15px;
  height: 15px;
  border: solid 1px #fff;
  background: #404040;
  opacity: 0.8;
}

.sect2 .swiper .swiper-pagination .swiper-pagination-bullet.swiper-pagination-bullet-active {
  background: #fff;
}

.sect3 {
  background: #63BFAA;
}

.sect3 .improve {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.sect3 .improve .icon {
  flex: 0 0 20%;
}

.sect3 .improve .icon img {
  width: 100%;
}

.sect3 .improve .desp {
  flex: 0 0 40%;
  padding: 0 0 20px;
  letter-spacing: 1px;
  line-height: 2em;
  color: #fff;
}

.sect3 .improve .spec {
  flex: 0 0 30%;
}

.sect3 .improve .spec .imgContainer3-1 {
  background: url(../../assets/energyTransitionReduceCarbon/pic3_01.png) center bottom no-repeat;
  background-size: cover;
}

@media screen and (min-width: 1367px) and (max-width: 1600px) {
  .kv .caption h1 {
    font-size: 48px;
  }
}

@media screen and (min-width: 1201px) and (max-width: 1366px) {
  .kv .caption h1 {
    font-size: 44px;
  }
}

@media screen and (min-width: 768px) and (max-width: 1200px) {
  .kv .caption {
    width: 100%;
    padding: 10px 10px;
  }

  .kv .caption h1 {
    font-size: 40px;
  }

  .sect1 .left {
    width: 100%;
  }

  .sect1 .right {
    width: 70%;
    margin: 0 15%;
  }

.sect3 .improve .icon {
  flex: 0 0 27%;
  order: 2;
}

.sect3 .improve .desp {
  flex: 0 0 100%;
  padding: 0 0 20px;
  order: 1;
}

.sect3 .improve .spec {
  flex: 0 0 40%;
  order: 3;
}
}

@media screen and (min-width: 1px) and (max-width: 767px) {
  .kv .caption {
    width: 100%;
    padding: 10px 10px;
  }

  .kv .caption h1 {
    font-size: 24px;
    text-shadow: 3px 3px 3px #00000066;
  }

  .sect1 .left {
    width: 100%;
  }

  .sect1 .right {
    width: 100%;
  }

  .sect2 .sectTit {
    font-size: 24px;
  }

  .sect3 .improve .icon {
    flex: 0 0 100%;
  }

  .sect3 .improve .icon img {
    width: 50%;
    margin: 0 25% 20px;
  }

  .sect3 .improve .desp {
    flex: 0 0 100%;
  }

  .sect3 .improve .spec {
    flex: 0 0 100%;
  }
}
</style>
